import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import bpo from "../assets/images_new/mnc.webp";
import garage from "../assets/images_new/garage.webp";
import controlroom from "../assets/images_new/control-room.webp";
import driver from "../assets/images_new/experienced-drivers.webp";
import team from "../assets/images_new/effective-data-management-team.webp";
import emergency from "../assets/images_new/emergency-response-team.webp";
import safety from "../assets/images_new/safety-first.webp";
import transport from "../assets/images_new/executive-transport.webp";
import qualified from "../assets/images_new/qualified-staff.webp";
import employee from "../assets/images_new/executive-transport.webp";
import leasing from "../assets/images_new/executive-leasing.webp";
import rent from "../assets/images_new/rent.webp";
import trip from "../assets/images_new/employee-trips.webp";
import event from "../assets/images_new/events-seminars.webp";
import transportCorporate from "../assets/images_new/transport-desk.webp";
import routing from "../assets/images_new/routing.webp";
import reporting from "../assets/images_new/management-reporting.webp";
import billing from "../assets/images_new/systemized.webp";
import medical from "../assets/images_new/driver-medical-test.webp";
import alcohol from "../assets/images_new/regular-alcohol-testing.webp";
import bg_test from "../assets/images_new/background-verification.webp";
import registration from "../assets/images_new/up-to-date.webp";
import monitoring from "../assets/images_new/fuel.webp";
import regulations from "../assets/images_new/law.webp";
import AOS from "aos";
AOS.init();
const Ourservice = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={8} md={12} className="pr-0">
              <div className="contact-banner text-center">
                <h4>Our Services</h4>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row className="mt-10">
            <Col xs={12} md={12} className="text-center">
              <div className="main-heading">
                <h3>
                  <span>Corporate</span> Services
                </h3>
              </div>
            </Col>
          </Row>
          <Row className="mt-30 gx-2 gy-2">
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={bpo} className="img-fluid" alt=""></img>
                <h6>Transportation for MNC/GCC</h6>
                <p>
                  Many IT companies in India provide transport facilities to
                  their employees for pick-up and drop.
                  <br />
                  Safety <br />
                  Reporting or Log In time of the employee <br />
                  Rotational shifts
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={team} className="img-fluid" alt=""></img>
                <h6>Effective Data Management Team</h6>
                <p>
                  Data management is the development and execution of
                  architectures, policies, practices and procedures in order to
                  manage the information lifecycle needs of an enterprise in an
                  effective manner.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={emergency} className="img-fluid" alt=""></img>
                <h6>24/7 Emergency Response Team</h6>
                <p>
                  Emergency calls are answered on a land line directly by one of
                  our team of highly skilled and experienced Incident Advisors,
                  who are mostly chemists and qualified Dangerous Goods Safety
                  Advisers. They advise callers on the best actions to take to
                  minimise the risk to people, the environment and property
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={driver} className="img-fluid" alt=""></img>
                <h6>Experienced Drivers</h6>
                <p>
                  All drivers are with minimum of 1 years of experience in the
                  same field. <br />
                  All drivers attend to duty in full uniform. <br />
                  All drivers shall be provided with laminated photo ID card.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={garage} className="img-fluid" alt=""></img>
                <h6>Own Garage</h6>
                <p>
                  Car repair is a lucrative and popular business. With new
                  technologies, such as electric vehicles and higher efficiency
                  standards, the role of mechanic will continue to evolve and
                  require continuing education. Opening your own garage to
                  repair cars can be challenging, but the payoff could be large.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={controlroom} className="img-fluid" alt=""></img>
                <h6>24/7 Control Room Facility</h6>
                <p>
                  A control room, operations center, or operations control
                  center (OCC) is a room serving as a central space where a
                  large physical facility or physically dispersed service can be
                  monitored and controlled.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={safety} className="img-fluid" alt=""></img>
                <h6>Safety First</h6>
                <p>
                  Safety is not simply found in a set of policies and
                  procedures. It is at front of mind at all times. It comes from
                  conditioning proper thought processes and behaviors, preparing
                  for situations, and knowing how to respond in ways that
                  protect the well being of our employees, those with whom we
                  work, and those we serve
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={transport} className="img-fluid" alt=""></img>
                <h6>Executive Transport</h6>
                <p>
                  A transportation ensures that shipments into or out of an
                  organization are handled quickly, safely, and within budget
                  constraints. This might include oversight of transportation
                  equipment and personnel operated by an organization. These
                  professionals might also coordinate with outside companies
                  that provides freight services.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={qualified} className="img-fluid" alt=""></img>
                <h6>Qualified Staff Members</h6>
                <p>
                  Having a good staff around you will help to lighten your work
                  load and let your mind focus on the important matters. <br />
                  The entire group of employees who work at a company. <br />
                  Those employees who work under a given supervisor. <br />
                  The act of holding a position at a company.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40" style={{ height: "503px" }}>
                <img src={employee} className="img-fluid" alt=""></img>
                <h6>Employee Transportation</h6>
                <p>
                  Whatever may be the employee number; we can arrange you secure
                  transportation facilities. As a dedicated team, we arrange the
                  transports with respect to the passenger numbers in a
                  well-organized way. We not only serve staff but also extend it
                  to guests. A highly comfortable travel for patrons is assured
                  without any complications.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40" style={{ height: "503px" }}>
                <img src={leasing} className="img-fluid" alt=""></img>
                <h6>Executive Leasing</h6>
                <p>
                  We are ready to provide the leased workers for the short-term
                  and long-term agreements especially in the payroll and tax
                  reporting etc. On the other side, we also offer the beneficial
                  way of experimenting the projects without the enhanced
                  responsibility of the human resource management. Our
                  professional team is ready to give the unique tour for the
                  properties to the probable lessees.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40" style={{ height: "503px" }}>
                <img src={rent} className="img-fluid" alt=""></img>
                <h6>Premium Rent a Cab</h6>
                <p>
                  All models of Indigo, Honda City, Toyota and Benz cars are
                  available in optimum rate for rent. We provide you with a
                  variety of rental schemes; within the city, out of station and
                  tour packages with and without drivers. Customer satisfaction
                  is our main objective. Charges that we offer are standard to
                  highly feasible.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={trip} className="img-fluid" alt=""></img>
                <h6>Employee Trips</h6>
                <p>
                  We also schedule travel plans for official employee trips.
                  Bus, train, flight, and car or any mode of transportation,
                  according to your budget will be well organized. All services
                  are provided in a highly ethical and professional environment.
                  With our expert team, official trips are planned perfectly
                  without any leakage of money.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={event} className="img-fluid" alt=""></img>
                <h6>Events / Seminars</h6>
                <p>
                  Are you conducting any corporate event and worried about
                  travel? We help you take your team to the event destination.
                  Even for educational meet-ups like seminars, exceptional
                  on-time transportation of staff is possible. We offer
                  professional service with a keen eye to time management,
                  especially during important business gatherings.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img
                  src={transportCorporate}
                  className="img-fluid"
                  alt=""
                ></img>
                <h6>Transport Desk & Ticketing</h6>
                <p>
                  We maintain a transport desk to serve you 24*7. If you have
                  any queries or doubts regarding travel you can feel free to
                  contact us and resolve your issues. Ticketing service is also
                  offered here. Any change with the boarding, changes in ticket
                  plan all labors are skillfully carried out.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={routing} className="img-fluid" alt=""></img>
                <h6>Rostering /Routing</h6>
                <p>
                  With the experienced expert team, we not only arrange
                  transport facility but also guide you with nominal routes. Our
                  routing team equipped with navigation systems and live route
                  updates will help you find the ideal route to reach the
                  desired destination in time. The mere rate is charged for
                  planning a perfect route according to the mode of the vehicle.
                  We aid you to choose wisely and save your money.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={reporting} className="img-fluid" alt=""></img>
                <h6>Management Reporting</h6>
                <p>
                  Documentation on every trip is prepared and submitted at the
                  management. It is highly useful for official trips. Our
                  documentation comprises an in-depth analysis of the trip. The
                  client can refer the report to get accurate details for the
                  entire travel. We provide a copy if requested which may be
                  used as a record for future references or for any legal
                  requirements.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={billing} className="img-fluid" alt=""></img>
                <h6>Systemized Billing</h6>
                <p>
                  Our billing system is absolutely digitalized; ensuring a fair
                  rate with no additional charges. We are an end to end
                  technology driven company offering a comfortable service to
                  customers. Since the billing is the automated probability of
                  occurrence of an error is almost zero. Our online transaction
                  platform is highly secure and supports all modes of transfer
                  as credit card/debit card and net banking.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

      </div>

      <div>
        <Container>
          <Row>
            <Col xs={12} md={12} className="text-center">
              <div className="main-heading">
                <h3>
                  <span>Compliances</span>
                </h3>
              </div>
            </Col>
          </Row>
          <Row className="mt-30 gx-2 gy-2 mb-5">
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={medical} className="img-fluid" alt=""></img>
                <h6>Driver Medical Test </h6>
                <p>
                  Our driver medical test ensures every driver is physically and
                  mentally fit to operate a vehicle safely. The examination
                  includes vision checks, blood pressure monitoring, general
                  health assessment, and fitness certification by qualified
                  medical professionals. This process helps reduce on-road risks
                  and ensures passenger safety.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={alcohol} className="img-fluid" alt=""></img>
                <h6>Regular Alcohol Testing </h6>
                <p>
                  To promote safe and responsible driving, we perform regular
                  alcohol testing for all drivers. Random and scheduled checks
                  are conducted using certified breath analyzers to ensure zero
                  tolerance for driving under the influence. This proactive
                  approach helps maintain safety, compliance, and customer
                  confidence.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service">
                <img src={bg_test} className="img-fluid w-100" alt=""></img>
                <h6>Background Verification </h6>
                <p>
                  We conduct thorough background verification for all drivers to
                  maintain the highest standards of trust and security. This
                  includes identity verification, address validation, criminal
                  record checks, and driving history review. Our strict
                  screening process ensures that only reliable and responsible
                  drivers are onboarded.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={registration} className="img-fluid" alt=""></img>
                <h6>UP-TO-DATE REGISTRATION </h6>
                <p>
                  Our team ensures that all our vehicles are up-to-date in terms
                  of registrations and renewals so that no fine and penalty
                  occurs.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={monitoring} className="img-fluid" alt=""></img>
                <h6>FUEL REFILL MONITORING </h6>
                <p>
                  Our staff and drivers ensure that all vehicles have sufficient
                  fuel so that they don’t breakdown while in transit.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="hive-service pt-40">
                <img src={regulations} className="img-fluid" alt=""></img>
                <h6>COMPLIANCE WITH LAWS AND REGULATIONS </h6>
                <p>
                  We make sure that all our vehicles comply with the motor
                  vehicle act and environmental benefits.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Ourservice;
